






import LayoutWithWsLogo from "@/components/layout/LayoutWithWsLogo.vue";
import WorkspaceForm from "@/views/workspaces/WorkspaceForm.vue";
import workspaceMixin from "@/mixins/workspace";
import mixins from "vue-typed-mixins";

export default mixins(workspaceMixin).extend({
  components: {
    LayoutWithWsLogo,
    WorkspaceForm
  },
  data() {
    return {
      eAdvocacy: localStorage.ea
    };
  }
});
